export enum EAction {
  TOGGLE_ASIDE_COLLAPSED,
  LOGGED_CHANGE
}